import '!wix-tpa-style-loader?mode=inline!sass-loader?{"includePaths": [".", "node_modules"]}!../../assets/styles/injected-style-multishare.global.scss';
import '../../assets/styles/injected-style-multishare.global.scss';
import './index-multishare.global.scss';
import 'fontawesome'



// WEBPACK FOOTER //
// ./apps/multishare/externals-multishare.js